import { useState } from 'react';

export default function EICReview() {
  const [formData, setFormData] = useState({
    status: 'pending',
    reviewedBy: 'Lebron Jordan',
    comments: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="space-y-6 mt-6">
      <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <h3 className="text-lg font-medium leading-6 text-gray-900">Executive Review</h3>
            <p className="mt-1 text-sm text-gray-500">
              Executive-in-Charge review and decision on crisis activation.
            </p>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6">
                <label htmlFor="status" className="block text-sm font-medium text-gray-700">
                  Review Status
                </label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                >
                  <option value="pending">Pending Review</option>
                  <option value="acknowledged">Acknowledged</option>
                  <option value="additional-info">Additional Information Needed</option>
                  <option value="approved">Approved for Crisis Activation</option>
                </select>
              </div>

              <div className="col-span-6">
                <label htmlFor="reviewedBy" className="block text-sm font-medium text-gray-700">
                  Reviewed By
                </label>
                <input
                  type="text"
                  id="reviewedBy"
                  name="reviewedBy"
                  value={formData.reviewedBy}
                  onChange={handleChange}
                  placeholder="Lebron Jordan"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="comments" className="block text-sm font-medium text-gray-700">
                  Executive Comments
                </label>
                <textarea
                  id="comments"
                  name="comments"
                  rows={6}
                  value={formData.comments}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Provide any comments, concerns, or additional requirements"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}